// Import Dependencies
import React, { Fragment } from 'react';
import { observer } from 'mobx-react';

// BrowserRouter
import { BrowserRouter } from 'react-router-dom';

// Global css files
import '~/common/styles/reset.css';
import '~/common/styles/default.css';
// Code not actually contained in the app
import '~/common/styles/placeholder.css';

// Routes
import Routes from './Routes.js';

@observer
export default class App extends React.Component {
    render() {
        return (
            // insert router
            <BrowserRouter>
                <Fragment>
                    <Routes />
                </Fragment>
            </BrowserRouter>
        );
    }
}
